import { Logger, LogContext } from './types';
import { consoleLogger } from './consoleLogger';
import { remoteLogger } from './remoteLogger';
import { ENV_CONFIG } from '@/config/env';

class CompositeLogger implements Logger {
  private loggers: Logger[] = [];

  constructor() {
    this.loggers.push(consoleLogger);
    
    if (ENV_CONFIG.IS_PROD) {
      this.loggers.push(remoteLogger);
    }
  }

  debug(message: string, context?: LogContext): void {
    this.loggers.forEach((logger) => logger.debug(message, context));
  }

  info(message: string, context?: LogContext): void {
    this.loggers.forEach((logger) => logger.info(message, context));
  }

  warn(message: string, context?: LogContext): void {
    this.loggers.forEach((logger) => logger.warn(message, context));
  }

  error(message: string, error?: Error, context?: LogContext): void {
    this.loggers.forEach((logger) => logger.error(message, error, context));
  }
}

export const logger = new CompositeLogger();
export type { Logger, LogContext } from './types';

